import { DatePipe, formatNumber } from '@angular/common';
import { AfterViewInit, Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatTableDataSource } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Subscription } from 'rxjs';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { EnterpriseConfigService } from 'src/app/core/services/enterprise-config.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';

@Component({
  selector: 'app-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.scss'],
  providers: [DatePipe]
})
export class ResourceComponent implements OnInit, AfterViewInit, OnDestroy {

  @BlockUI() blockUI: NgBlockUI;
  dataSource = new MatTableDataSource();
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService!: Subscription;
  subscription = new Subscription();
  enterpriseId!: string;

  displayedColumns: string[] = [];
  storageDigitalContractValue = '0';
  unitStorageDigitalContract = '';
  storageDigitalContract = 0;
  now = new Date();
  entType: number = 0;

  columnDefinitions = [
    { def: 'id', showMobile: true },
    { def: 'name', showMobile: true },
    { def: 'status', showMobile: true },
    { def: 'quantityAvailable', showMobile: true },
    { def: 'unit', showMobile: true },
    { def: 'endDate', showMobile: false },
    { def: 'lockedServiceDate', showMobile: false },
    // { def: 'quantityWarning', showMobile: false },
    // { def: 'quantityExpiredWarning', showMobile: false }
  ];


  constructor(
    private dialogRef: MatDialogRef<ResourceComponent>,
    private dialog: MatDialog,
    private enterpriseConfigService: EnterpriseConfigService,
    private datePipe: DatePipe,
    private responsiveService: ResponsiveService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.entType = Number(localStorage.getItem('entType'));
  }

  ngOnInit() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    // popup cần số liệu mới nhất mỗi lần mở -> bỏ cache rồi fetch
    this.enterpriseConfigService.invalidate();
    this.enterpriseConfigService.getResources(enterpriseId).subscribe((res) => {
      if (res && res.code == 200) {
        this.dataSource.data = this.mapEnterpriseResources(res.data);
      }
    });
  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }


  close() {
    this.dialogRef.close();
  }

  mapEnterpriseResources(resources: any[]): any[] {
    return resources.map((data: any, index: number) => ({
      ...data,
      index: index,
      serviceName: this.convertDataNameAndUnit(data.serviceName, data.quantity).name,
      expiredDate: this.datePipe.transform(data.expiredDate ? data.expiredDate : resources.find((rs) => rs.serviceName === 'CONTRACT').expiredDate, 'dd/MM/yyyy'),
      lockedServiceDate: this.datePipe.transform(data.lockedServiceDate, 'dd/MM/yyyy'),
      unit:  this.convertDataNameAndUnit(data.serviceName, data.quantity).unit,
      quantity:
        data.serviceName == 'DIGITAL_CONTRACT' ||  data.serviceName == 'FILE_LARGE_CAPACITY' ? this.setValueStorageDigitalContract(data.quantity).value : formatNumber(Number(data.quantity), 'en-US', '1.0-0').replace(/,/g, '.')
    }));
  }

  convertDataNameAndUnit(dataName: string, quantity: number) {
    let name = '';
    let unit = '';
    switch (dataName) {
      case 'CONTRACT':
        name = 'analysis.analysis_report_enterprise.number_use_contract';
        unit = 'analysis.analysis_report_enterprise.unit_use_contract';
        break;
      case 'EKYC':
        name = 'analysis.analysis_report_enterprise.number_use_ekyc';
        unit = 'analysis.analysis_report_enterprise.signed_turn';
        break;
      case 'ADVANCE_EKYC':
        name = 'analysis.analysis_report_enterprise.number_use_ekyc_advanced';
        unit = 'analysis.analysis_report_enterprise.signed_turn';
        break;
      case 'SMS_MONEY':
        name = 'analysis.analysis_report_enterprise.number_use_money_sms_2';
        unit = 'analysis.analysis_report_enterprise.vnd';
        break;
      case 'DIGITAL_CONTRACT':
        name = 'analysis.analysis_report_enterprise.number_use_storage_dig_contract';
        unit = this.setValueStorageDigitalContract(quantity).unit;
        break;
      case 'MOIT_VERIFY_MONEY':
        name = 'analysis.analysis_report_enterprise.number_use_money_email_2';
        unit = 'analysis.analysis_report_enterprise.vnd';
        break;
      case 'FILE_LARGE_CAPACITY':
        name = 'analysis.analysis_report_enterprise.number_use_file_large_capacity';
        unit = this.setValueStorageDigitalContract(quantity).unit;
        break;
      case 'CONTRACT_LIGHT':
        name = 'analysis.analysis_report_enterprise.number_use_contract_1MB';
        unit = 'analysis.analysis_report_enterprise.unit_use_contract';
        break;
    }
    return { name, unit };
  }

  // convertByteToMB(quantity: any) {
  //   return formatNumber(Number((quantity / 1048576).toFixed(2)), 'en-US', '1.0-0').replace(/,/g, '.');
  // }

  setValueStorageDigitalContract(quantity: any) {
    const value = quantity;
    const gigabyte = 1073741824;
    const megabyte = 1048576;
    const kilobyte = 1024;
    if (value >= gigabyte) {
      this.calculateCapacity(value, gigabyte);
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '0' && this.storageDigitalContractValue.indexOf('.') > 0) {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '.') {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      this.unitStorageDigitalContract = ' GB';
    } else if (value > gigabyte / 10) {
      this.storageDigitalContractValue = (Math.floor((value / gigabyte) * 1000) / 1000).toFixed(3);
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '0' && this.storageDigitalContractValue.indexOf('.') > 0) {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '.') {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      this.unitStorageDigitalContract = ' GB';
    } else if (value === megabyte) {
      this.storageDigitalContractValue = '1';
      this.unitStorageDigitalContract = ' MB';
    } else if (value > megabyte / 10) {
      this.calculateCapacity(value, megabyte);
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '0' && this.storageDigitalContractValue.indexOf('.') > 0) {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '.') {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      this.unitStorageDigitalContract = ' MB';
    } else if (value === kilobyte) {
      this.storageDigitalContractValue = '1';
      this.unitStorageDigitalContract = ' KB';
    } else if (value > 0) {
      this.calculateCapacity(value, kilobyte);
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '0' && this.storageDigitalContractValue.indexOf('.') > 0) {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '.') {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      this.unitStorageDigitalContract = ' KB';
    } else {
      this.storageDigitalContractValue = '0';
      this.storageDigitalContract = 0;
      this.unitStorageDigitalContract = ' KB';
    }
    return {
      value: this.storageDigitalContractValue,
      unit: this.unitStorageDigitalContract
    };
  }

  calculateCapacity(value: any, type: any) {
    this.storageDigitalContract = value / type;
    if (value % type === 0) {
      this.storageDigitalContractValue = (value / type).toString();
    } else {
      const phanNguyen = Math.floor(value / type);
      const phanDu = value % type;
      this.storageDigitalContractValue = phanNguyen.toString() + (Math.floor((phanDu / type) * 1000) / 1000).toFixed(3).substring(1);
    }
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
  }

  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
    this.subscription.unsubscribe();
  }

}


